<div class="heatmap-section" [ngClass]="{'dark-mode': isDarkTheme}">
  
  <div class="heatmap-header">
    <div class="heatmap-title">Threats by Sector Heatmap</div>
    <i [class]="'bi ' + (isMinimized ? 'bi-arrows-angle-expand' : 'bi-dash-circle')" 
       class="minimize-icon" 
       (click)="toggleMinimize()"
       title="Minimize/Expand"></i>
  </div>

  <div class="heatmap-content" *ngIf="!isMinimized">

  <!-- Controls -->
  <div class="heatmap-controls">
    <div class="control-group">
      <div class="sort-buttons">
        <button
          [class.active]="industryLimit === 5"
          (click)="changeIndustryLimit(5, 'Top 5')"
          class="chi-button sort-btn">
          Top 5
        </button>
        <button
          [class.active]="industryLimit === 10"
          (click)="changeIndustryLimit(10, 'Top 10')"
          class="chi-button sort-btn">
          Top 10
        </button>
        <button
          [class.active]="industryLimit === 0"
          (click)="changeIndustryLimit(0, 'All')"
          class="chi-button sort-btn">
          All
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="heatmap-container">
    <div class="heatmap-wrapper">
      <table class="heatmap-table">
        <thead>
          <tr>
            <th class="row-header-cell">Sector</th>
            <th *ngFor="let threatType of threatTypes" class="threat-type-header">{{ threatType }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let industry of getSortedIndustries()">
            <td class="row-header-cell">{{ industry }}</td>
            <td 
              *ngFor="let threatType of threatTypes"
              class="heatmap-cell"
              [style.background-color]="getCellColor(getCell(industry, threatType))"
              [class.has-data]="getCell(industry, threatType)"
              [title]="industry + ' - ' + threatType">
              <span class="cell-value">{{ getCellValue(getCell(industry, threatType)) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  </div>

</div>
